import { Link } from "react-router-dom";
import { founder } from "@/data/site/brand";

interface ReviewedByProps {
  reviewer?: string;
  credentials?: string;
  /** ISO date string. Defaults to today. */
  date?: string;
  profileUrl?: string;
}

/**
 * Compact E-E-A-T stamp for evergreen content. Tells readers (and Google's
 * Quality Rater Guidelines) who reviewed the page and when, with a link to
 * the firm's editorial standards.
 */
export const ReviewedBy = ({
  reviewer = founder.name,
  credentials = founder.credentials,
  date,
  profileUrl = "/about/franklin-sofi",
}: ReviewedByProps) => {
  const reviewDate = date || new Date().toISOString().slice(0, 10);
  const formatted = new Date(reviewDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="mb-8 flex items-center gap-4 text-sm text-muted-foreground border border-border bg-secondary/40 rounded-lg px-5 py-4 not-prose">
      <img
        src={founder.image}
        alt={reviewer}
        className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover object-top border-2 border-gold shrink-0"
        loading="lazy"
       width={96} height={96} />
      <div className="leading-snug min-w-0">
        <div className="text-[15px]">
          <span>Professionally reviewed by </span>
          <Link to={profileUrl} className="font-semibold text-navy hover:text-gold transition-colors">
            {reviewer}
          </Link>
          {credentials && <span className="text-muted-foreground">, {credentials}</span>}
        </div>
        <div className="text-xs mt-1 flex flex-wrap items-center gap-x-2 gap-y-1">
          <span>
            Last reviewed{" "}
            <time dateTime={reviewDate} className="font-medium text-navy">
              {formatted}
            </time>
          </span>
          <span aria-hidden className="text-border">·</span>
          <Link
            to="/editorial-standards"
            className="font-semibold text-navy hover:text-gold"
          >
            Editorial standards
          </Link>
        </div>
      </div>
    </div>
  );
};

